import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { KeyRound } from 'lucide-react';
import api from '../lib/api';
import { toast } from 'sonner';

export const ForceChangePassword = () => {
  const { user, setUser, logout } = useAuth();
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) { toast.error('Konfirmasi password tidak sama'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { current_password: form.current, new_password: form.next });
      toast.success('Password berhasil diganti');
      setUser({ ...user, must_change_password: false });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengganti password');
    } finally {
      setSaving(false);
    }
  };

  const field = (key, label, testid) => (
    <div className="space-y-1">
      <Label>{label}</Label>
      <Input type="password" value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} required data-testid={testid} />
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="force-change-password">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-red-600" /> Ganti Password Anda</CardTitle>
          <p className="text-sm text-slate-600">Password Anda baru saja diatur oleh admin. Buat password baru milik Anda sendiri untuk melanjutkan.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-3">
            {field('current', 'Password dari Admin', 'force-pw-current')}
            {field('next', 'Password Baru', 'force-pw-new')}
            {field('confirm', 'Ulangi Password Baru', 'force-pw-confirm')}
            <p className="text-xs text-slate-500">Minimal 8 karakter, mengandung huruf besar dan angka.</p>
            <Button type="submit" className="w-full bg-red-600 hover:bg-red-700" disabled={saving} data-testid="force-pw-submit">
              {saving ? 'Menyimpan...' : 'Simpan & Lanjutkan'}
            </Button>
            <Button type="button" variant="ghost" className="w-full" onClick={logout} data-testid="force-pw-logout">Keluar</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
